import type { StudentIntervention } from '@innovamat/glow-api-client';

const formatStudentFullName = (
  firstName?: string | null,
  lastName?: string | null
): string => {
  if (!firstName) {
    return 'Unknown';
  }

  if (!lastName || lastName.trim().length === 0) {
    return firstName;
  }

  return `${firstName} ${lastName.trim()}`;
};

function createCatchUpChartTooltip(students: StudentIntervention[]) {
  const studentUuidMap = new Map(
    students.map((student) => [student.uuid, student])
  );

  return function ({
    seriesIndex,
    dataPointIndex,
    w,
  }: {
    seriesIndex: number;
    dataPointIndex: number;
    w?: {
      globals: {
        seriesNames: string[];
      };
    };
  }): string {
    let student: StudentIntervention | undefined;

    if (w?.globals?.seriesNames?.[seriesIndex]) {
      const seriesName = w.globals.seriesNames[seriesIndex];
      const parts = seriesName.split('::');
      if (parts.length > 1) {
        const uuid = parts[1];
        student = studentUuidMap.get(uuid);
      }
    }

    if (!student && seriesIndex < students.length) {
      student = students[seriesIndex];
    }

    if (!student) {
      return '';
    }

    const fullName = formatStudentFullName(student.firstName, student.lastName);
    const weekData = student.weeks[dataPointIndex];
    const score = weekData?.arithmeticFluencyScore;
    const value = score ? Number(score.toFixed(1)) : null;

    if (value === null || value === undefined) {
      return `
        <div 
          class="apexcharts-tooltip-box" 
          style="background-color: #4a4a4a; color: white; padding: 6px 10px; border-radius: 6px; font-size: 12px; font-family: Helvetica, Arial, sans-serif; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);"
        >
          <div>
            no data
          </div>
        </div>
      `.trim();
    }

    return `
      <div 
        class="apexcharts-tooltip-box" 
        style="background-color: #4a4a4a; color: white; padding: 6px 10px; border-radius: 6px; font-size: 12px; font-family: Helvetica, Arial, sans-serif; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);"
      >
        <div style="margin-bottom: 4px; font-weight: 500;">
          ${fullName}
        </div>
        <div>
          ${value} op/min
        </div>
      </div>
    `.trim();
  };
}

export { createCatchUpChartTooltip };
